/** @format */

import { Box, CircularProgress, Icon, Typography } from '@mui/material';
import { CloudDone as CloudDoneIcon } from '@mui/icons-material';

export default function SyncStutus({ value }) {
  if (value === 100) {
    return (
      <Icon>
        <CloudDoneIcon sx={{ color: 'success.main' }} />
      </Icon>
    );
  } else {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress variant="determinate" value={value} size={30} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: 'text.secondary', fontSize: '0.5rem' }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    );
  }
}
